export const topResults = "fQMVRc";
export const allResults = "xDqb0b";
export const recentResults = "pseX6d";
export const moreResults = "fQB0mb";
export const pinned = "Oy$hOd";
export default {topResults,allResults,recentResults,moreResults,pinned};